import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../Assets/soft-skills-loader-animation.json'; // ⬅️ Add this file in /src/Assets

const SoftSkillsLoader = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/soft-skills');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-center items-center min-h-[70vh] w-full max-w-[950px] mx-auto gap-8">
      <div className="w-[300px] md:w-[400px] lg:w-[500px]">
        <Lottie animationData={animationData} loop={true} />
      </div>
      <p className="text-lg md:text-xl font-semibold text-stone-800 font-sora text-center">
        Kumar is brushing up your people skills... 🗣️✨
      </p>
    </div>
  );
};

export default SoftSkillsLoader;
